import React, { useState } from "react"
import { Grid, FormControl, Select, MenuItem, CircularProgress } from "@material-ui/core"
import ApiService from "@/services/Api"
import { Notification } from "@/components"
import useDidMount from "@/hooks/useDidMount"
import { ContactsFiltersConditions } from "@/protocols/ClientCatalogFilterProtocol"

type ContactImportCreationProps = {
	condition: ContactsFiltersConditions<"client_catalog_contacts_created_by_contacts_import">
	onChange: (condition: ContactsFiltersConditions<"client_catalog_contacts_created_by_contacts_import">) => void
}

const MAX_IMPORT_HISTORY_COUNT_TO_FILTER = 30

type ImportHistory = { id: number }

const ContactCreatedByImportFeatureFilterCondition: React.FC<ContactImportCreationProps> = (props) => {
	const { condition, onChange } = props
	const [importHistoryList, setImportHistoryList] = useState<ImportHistory[]>([])
	const [loading, setLoading] = useState(false)

	const getContactImportHsitory = async () => {
		setLoading(true)
		try {
			const response = await ApiService.get("/clients/contacts/imports-history-to-filter")
			const data: ImportHistory[] = response.data

			if (response.data) {
				setImportHistoryList(data.slice(0, MAX_IMPORT_HISTORY_COUNT_TO_FILTER))
			}
		} catch (error) {
			Notification.error({ message: "Houve um erro ao carregar o histórico" })
		}
		setLoading(false)
	}

	const handleChangeSelectedImportHistoryId = (id: number) => {
		onChange({
			type: "client_catalog_contacts_created_by_contacts_import",
			operator: "equal",
			filterData: {
				client_catalog_contacts_created_by_contacts_import_id: id
			}
		})
	}

	useDidMount(() => {
		getContactImportHsitory()
	})

	return (
		<Grid container direction="row" spacing={2}>
			<Grid item xs={12}>
				<FormControl fullWidth variant="outlined" size="small">
					<Select
						value={condition.filterData?.client_catalog_contacts_created_by_contacts_import_id || ""}
						onChange={({ target }) => handleChangeSelectedImportHistoryId(Number(target.value))}
						endAdornment={
							loading ? <CircularProgress size={20} thickness={4} /> : null
						}
					>
						{importHistoryList.map(item => (
							<MenuItem key={item.id} value={item.id}>
								Importação #{item.id}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</Grid>
		</Grid>
	)
}

export default ContactCreatedByImportFeatureFilterCondition
